import React from 'react';
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Grid2 from "@mui/material/Unstable_Grid2";
import logo from "../images/logo.png";
import Avatar from "@mui/material/Avatar";
import {Grid, Link} from "@mui/material";

import IconButton from "@mui/material/IconButton";
import {Facebook, Instagram, LinkedIn, Twitter, Google} from "@mui/icons-material";

const Footer = () => {
    return (

        <Box
            sx={{
                backgroundColor: '#f9f9f9',
                padding: '30px 0',
                textAlign: 'center',
                //px: {xs: 1}
            }}
        >
            {/* Logo and Company Name */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    mb: 3,
                    flexDirection: { xs: 'column', md: 'row' }, // Column on small screens, row on larger
                }}
            >
                <Avatar
                    src={logo}
                    alt="Logo"
                    sx={{
                        width: { xs: 75, md: 80 }, // Smaller on mobile
                        height: { xs: 75, md: 80 },
                        marginRight: { md: 2 }, // Margin-right only on larger screens
                        mb: { xs: 1, md: 0 }, // Margin bottom on small screens for spacing
                    }}
                />
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 'bold',
                        color: '#3f72b5',
                        fontSize: { xs: '24px', md: '34px' }, // Smaller font size for mobile
                    }}
                >
                    CP
                </Typography>
            </Box>

            {/* Navigation Links */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: { xs: 2, md: 6 }, // Smaller gap on small screens
                    mb: 3,
                    flexWrap: 'wrap', // Allows wrapping on small screens
                }}
            >
                <Link href="/electricite-generale" underline="none" sx={{ color: '#3f72b5', fontSize: { xs: '17px', md: '20px' } }}>
                    Électricité générale
                </Link>
                <Link href="/mobilite-electrique" underline="none" sx={{ color: '#3f72b5', fontSize: { xs: '17px', md: '20px' } }}>
                    Mobilité éléctrique
                </Link>
                <Link href="/energie-renouvelable" underline="none" sx={{ color: '#3f72b5', fontSize: { xs: '17px', md: '20px' } }}>
                    Panneaux solaires
                </Link>
                <Link href="/domotique" underline="none" sx={{ color: '#3f72b5', fontSize: { xs: '17px', md: '20px' } }}>
                    Domotique
                </Link>
                <Link href="/sécurité" underline="none" sx={{ color: '#3f72b5', fontSize: { xs: '17px', md: '20px' } }}>
                    Sécurité
                </Link>
            </Box>

            {/* Social Media Icons */}
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    gap: { xs: 2, md: 3 }, // Reduced gap on mobile screens
                    mb: 3,
                }}
            >
                <IconButton href="https://www.google.com/search?sca_esv=e02818271ce7f460&hl=fr&gl=fr&tbm=lcl&sxsrf=ADLYWIJ0YaJsY3kK1t8XJh9c04rI7AlETw:1730553062831&q=CHAMROUK+PRODUCTION+Avis&rflfq=1&num=20&stick=H4sIAAAAAAAAAONgkxIxNDMzMgES5haG5oYWhiZGFmaGGxgZXzFKOHs4-gb5h3orBAT5u4Q6h3j6-yk4lmUWL2LFKQUAk5WW_lEAAAA&rldimm=16624166781718142861&sa=X&ved=2ahUKEwigrczE3L2JAxWuU6QEHZQjB4AQ9fQKegQILhAF&biw=1536&bih=703&dpr=1.25#lkt=LocalPoiReviews"
                            sx={{ color: '#3f72b5', fontSize: { xs: '28px', md: '32px' } }}
                            target="_blank"
                            rel="noopener noreferrer">
                    <Google fontSize="inherit" />
                </IconButton>
                <IconButton href="https://fr.linkedin.com/in/chamrouk-production-886182223"
                            sx={{ color: '#3f72b5', fontSize: { xs: '28px', md: '32px' } }}
                            target="_blank"
                            rel="noopener noreferrer"
                >
                    <LinkedIn fontSize="inherit" />
                </IconButton>
            </Box>

            {/* Copyright Text */}
            <Typography
                variant="body2"
                sx={{
                    color: '#A0A0A0',
                    fontSize: { xs: '14px', md: '16px' }, // Slightly smaller text on small screens
                }}
            >
                © 2024 CP. All rights reserved.
            </Typography>
        </Box>


    );
};

export default Footer;